import React from "react";

import { Carousel } from '../basic/carousel.js'
import { wrapCollectionLayout } from "@quintype/components";
import { CollectionName } from "../basic/collection-name.js";
import './half-screen-slider.module.css';
import {getNumberOfStoriesToShow} from "../../utils";

function HalfImageSliderBase({ collection, stories = [], associatedMetadata, config}) {
  const  {'show_collection_name': collectionName = true} = associatedMetadata;
  return <div styleName='container' className="wrapper" data-testid ='half-image-component'>
    {collectionName ? <CollectionName name={collection.name} type="large" section={collection}/> : null}
    <Carousel
      stories={stories}
      infinite={getNumberOfStoriesToShow(associatedMetadata['number_of_stories_to_show']) > 1}
      config={config}
      collection={collection}
      autoplay={associatedMetadata['set_scroll_speed'] !== 0}
      autoplaySpeed={associatedMetadata['set_scroll_speed']}
      rtl={config['theme-attributes']['language_direction'] === 'right'}
      arrows={associatedMetadata['show_arrows']}
      collectionName={associatedMetadata['show_collection_name']}
      numberOfStoriesToShow={getNumberOfStoriesToShow(associatedMetadata['number_of_stories_to_show']) || undefined}
      dots={associatedMetadata['dots']}
      associatedMetadata={associatedMetadata}
    />
  </div>
}

export const HalfImageSlider = wrapCollectionLayout(HalfImageSliderBase);
